import React, { useState } from "react";
import "./Header.css";
import { Link, useLocation } from "react-router-dom";
import { Nav, Navbar } from "react-bootstrap";
import Common_download_btn from "../common/common-download-btn/Common_download_btn";

function Header() {
  const location = useLocation();
  const [expanded, setExpanded] = useState(false);

  return (
    <>
      <section className='Header_holder'>
        <Navbar expand="lg" className="Header" expanded={expanded}>
          <div className="container">
            <Navbar.Brand as={Link} to="/" onClick={() => setExpanded(false)}>
              <div className="web_logo_holder">
                <img
                  className="logo_img"
                  src={process.env.PUBLIC_URL + "/assets/images/logo/logo.png"}
                  alt="Rent Easy  logo"
                />
              </div>
            </Navbar.Brand>

            <div className="d-block d-lg-none">
              <Link to={"https://play.google.com/"} target='_blank'>
                <Common_download_btn btnText="Get the App" />
              </Link>
            </div>

            <Navbar.Toggle aria-controls="basic-navbar-nav" onClick={() => setExpanded(!expanded)} />

            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="mx-auto">
                <Nav.Link
                  as={Link}
                  to="/"
                  onClick={() => setExpanded(false)}
                  className={location.pathname === "/" ? "active" : ""}
                >
                  Home
                </Nav.Link>

                <Nav.Link
                  as={Link}
                  to="/about-us"
                  onClick={() => setExpanded(false)}
                  className={location.pathname === "/about-us" ? "active" : ""}
                >
                  About Us
                </Nav.Link>


                <Nav.Link
                  as={Link}
                  to="/contact-us"
                  onClick={() => setExpanded(false)}
                  className={location.pathname === "/contact-us" ? "active" : ""}
                >
                  Contact Us
                </Nav.Link>
              </Nav>

              <div className="d-none d-lg-block">
                <Link to={"https://play.google.com/"} target='_blank'>
                  <Common_download_btn btnText="Get the App" Linking="https://play.google.com/" />
                </Link>
              </div>

            </Navbar.Collapse>
          </div>
        </Navbar>
      </section>
    </>
  );
}

export default Header;
